import React, { useEffect, useState } from 'react'
import { App, Button, Divider, Flex, Input, Modal, Typography } from 'antd'
import { useNavigate, useParams } from 'react-router-dom'
import { LeftOutlined } from '@ant-design/icons'
import { FaRegEdit } from 'react-icons/fa'
import { database } from '../../utils/firebase'

const { Title, Text } = Typography
const titleStyle = { padding: '0', margin: '0' }
const textStyle = { minHeight: '60px' }
const flexItemStyle = { flex: 1, padding: '8px' }

const ViewSoapNotes = () => {
  const [soapNote, setSoapNotes] = useState() // State for SOAP notes
  const [info, setInfo] = useState() // State for general info
  const [viewEditModal, setViewEditModal] = useState(false) // State to control modal visibility
  const [currentEditField, setCurrentEditField] = useState('') // State for the field currently being edited
  const [currentEditValue, setCurrentEditValue] = useState('') // State for the value of the field currently being edited
  const [modalTitle, setModalTitle] = useState('')
  const { message } = App.useApp()
  const { chatID } = useParams()
  const navigate = useNavigate()

  const queryParams = new URLSearchParams(location.search)
  const isSubsequent = queryParams.get('subsequentSoapNotes')

  const fetchInfo = (chatID) => {
    chatID = chatID.replace('_labs', '').replace('_imaging', '')

    database.ref(`archiveConversations/${chatID}`).once('value', (snapshot) => {
      const response = snapshot.val()
      console.log('response Info', response)
      setInfo(response)
    })
  }

  const fetchViewSoapNote = (chatID) => {
    chatID = chatID.replace('_labs', '').replace('_imaging', '')

    database.ref(`archiveConversations/${chatID}`).once('value', (snapshot) => {
      const response = snapshot.val()
      console.log('response soapnotes', response)
      if (response && isSubsequent) {
        setSoapNotes(response?.subsequentSoapNotes)
      } else if (response) {
        setSoapNotes(response?.soapNotesData)
      }
    })
  }

  useEffect(() => {
    fetchViewSoapNote(chatID) // Fetch SOAP notes on mount
    fetchInfo(chatID) // Fetch general info on mount
  }, [chatID])

  const handleEditClick = (title, field, value) => {
    setModalTitle(title)
    setCurrentEditField(field) // Set the current field being edited
    setCurrentEditValue(value) // Set the value of the field currently being edited

    setViewEditModal(true) // Open the modal
  }

  const handleLabEdits = () => {
    navigate(`/labedits/${chatID}`)
  }

  const handleModalSave = () => {
    // Update the local state with the new value
    setSoapNotes(prev => ({ ...prev, [currentEditField]: currentEditValue }))
    setViewEditModal(false) // Close the modal
  }

  const handleSaveSoapNotes = () => {
    const updatedChatID = chatID.replace('_labs', '').replace('_imaging', '')
    database.ref(`archiveConversations/${updatedChatID}${isSubsequent ? '/subsequentSoapNotes/' : '/soapNotesData/'}${currentEditField}`).set(currentEditValue)
      .then(() => {
        console.log('Firebase updated successfully')
        message.success('Success!')
      })
      .catch(error => {
        console.error('Error updating Firebase:', error)
      })
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#FFF3F2',
        padding: '10px 12px',
        borderBottom: '3px solid #DF7467',
      }}>
        <Button type="text" size="small" icon={<LeftOutlined />} onClick={() => navigate(-1)} />
        <Title style={{ padding: 0, margin: 0 }} level={5}>SOAP Notes</Title>
      </div>
      <div style={{ padding: '9px 0 0 10px' }}>
        <Text strong style={{ marginLeft: '10px' }}>{info?.patientName}</Text>
        <Text strong> -Diagnosis: {info?.assessment}</Text>
      </div>
      <div style={{ padding: '9px 0 0 10px' }}>
        <Text strong style={{ marginLeft: '10px' }}>Chat ID:</Text>
        <Text>{chatID}</Text>
      </div>
      <Divider style={{ margin: 0 }} />
      <Flex vertical style={{ flex: 1, padding: '8px' }}>
        <div style={flexItemStyle}>
          <Flex align="center" gap="small">
            <Title style={titleStyle} level={5} strong>Subjective Symptoms:</Title>
            <FaRegEdit style={{ borderColor: '#DF7467', color: '#DF7467' }}
                       onClick={() => handleEditClick('Subject symptoms', 'symptoms', soapNote?.symptoms)} />
          </Flex>
          <Text style={textStyle}>{soapNote?.symptoms}</Text>
        </div>
        <div style={flexItemStyle}>
          <Flex align="center" gap="small">
            <Title style={titleStyle} level={5} strong>Objective Symptoms:</Title>
            <FaRegEdit style={{ borderColor: '#DF7467', color: '#DF7467' }}
                       onClick={() => handleEditClick('Objective symptoms', 'findings', soapNote?.findings)} />
          </Flex>
          <Text style={textStyle}>{soapNote?.findings}</Text>
        </div>
        <div style={flexItemStyle}>
          <Flex align="center" gap="small">
            <Title style={titleStyle} level={5} strong>Assessment:</Title>
            <FaRegEdit style={{ borderColor: '#DF7467', color: '#DF7467' }}
                       onClick={() => handleEditClick('Assessment', 'assessment', soapNote?.assessment)} />
          </Flex>
          <Text style={textStyle}>{soapNote?.assessment}</Text>
        </div>
        <div style={flexItemStyle}>
          <Flex align="center" gap="small">
            <Title style={titleStyle} level={5} strong>Plan:</Title>
            <FaRegEdit style={{ borderColor: '#DF7467', color: '#DF7467' }}
                       onClick={() => handleEditClick('Plan', 'plan', soapNote?.plan)} />
          </Flex>
          <Text style={textStyle}>{soapNote?.plan}</Text>
        </div>
      </Flex>

      <Flex vertical style={{ padding: '24px', background: '#f9f9f9', alignItems: 'center' }} gap="small">
        <Button
          onClick={handleSaveSoapNotes}
          type="primary"
          shape="round"
          style={{
            width: '180px',
            marginBottom: '3px',
            backgroundColor: '#DF7467',
            borderColor: '#DF7467',
          }}
        >
          Save SOAP Notes
        </Button>
        <Button
          onClick={handleLabEdits}
          type="default"
          shape="round"
          style={{
            width: '180px',
            borderColor: '#DF7467',
            color: '#DF7467',
          }}
        >
          Suggests edits to triage
        </Button>
      </Flex>

      <Modal
        title={`Edit ${modalTitle}`}
        open={viewEditModal}
        onCancel={() => setViewEditModal(false)}
        onOk={handleModalSave}
      >
        <Input.TextArea
          value={currentEditValue}
          onChange={(e) => setCurrentEditValue(e.target.value)}
          rows={4}
        />
      </Modal>
    </div>
  )

}

export default ViewSoapNotes
